var render = function render(){var _vm=this,_c=_vm._self._c;return _c('thead',[_c('tr',[_vm._l((_vm.columnHeaders),function(column){return [_c('TableTh',{attrs:{"text":column.title,"sort":column.sort},on:{"sortItems":_vm.sortItems}})]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }